/* eslint-disable jira/filename-case */

import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import {
	composeLayouts,
	type Layout,
} from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';

export const globalSettingsLayout: Layout = composeLayouts(globalLayout);
